import { getRecentlyUsedFonts } from "store/features/memeGenerator/utils/getRecentlyUsedFonts";
import { store, useAppDispatch, useAppSelector } from "store/store";
import { setRecentlyUsedFonts, setIsLoadingRecentlyUsedFonts } from "store/features/memeGenerator/actions";
import { FontSources } from "store/features/memeGenerator/types/recentlyUsedFont";
import { MemeGeneratorState } from "store/features/memeGenerator/types";

export const useRecentlyUsedFonts = () => {
    const { isLoading, list } = useAppSelector((store) => store.memeGenerator.recentlyUsedFonts);
    const dispatch = useAppDispatch();

    async function handleLoad() {
        if (isLoading) return;
        dispatch(setIsLoadingRecentlyUsedFonts(true));
        const fonts = getRecentlyUsedFonts();
        await Promise.all(
            fonts
                .filter((font) => font.source === "google")
                .map((font) => {
                    if (font.source === FontSources.WEBFONT) return;
                    const googleFont = store
                        .getState()
                        .memeGenerator.googleFonts.list.find((_f) => _f.family === font.family);
                    if (!googleFont) return;
                    return googleFont;
                })
                .filter((f): f is MemeGeneratorState["googleFonts"]["list"][number] => !!f)
                .map((f) =>
                    f.variants.filter((v) => v === "regular").map((v) => ({ family: f.family, url: f.files[v] })),
                )
                .flat()
                .map((f) => loadSingleFontUrl(f.family, f.url)),
        );
        dispatch(setRecentlyUsedFonts(fonts));
        dispatch(setIsLoadingRecentlyUsedFonts(false));
    }

    async function loadSingleFontUrl(family: string, url: string) {
        const fontFile = new FontFace(family, `url(${url})`);
        document.fonts.add(fontFile);
        await fontFile.load();
    }

    return {
        recentlyUsedFonts: list,
        handleRecentlyUsedFontsLoad: handleLoad,
        isLoadingRecentlyUsedFonts: isLoading,
    };
};
